import {User} from '@models/user/user';
import {USER_ROLE} from '@constants/user-role.constant';

export class Role {
  isSuperAdminRole: boolean = false;
  isAdminRole: boolean = false;
  isTechAdminRole: boolean = false;
  isAnalyticsRole: boolean = false;
  isUserRole: boolean = false;
  isDistributorRole: boolean = false;
  isViewerRole: boolean = false;

  constructor(user: User) {
    this.isSuperAdminRole = false;
    this.isAdminRole = false;
    this.isTechAdminRole = false;
    this.isAnalyticsRole = false;
    this.isUserRole = false;
    this.isDistributorRole = false;
    this.isViewerRole = false;

    switch (user.role) {
      case USER_ROLE.SUPERADMIN: {
        this.isSuperAdminRole = true;
        break;
      }

      case USER_ROLE.TECH_ADMIN: {
        this.isTechAdminRole = true;
        break;
      }

      case USER_ROLE.ADMIN: {
        this.isAdminRole = true;
        break;
      }

      case USER_ROLE.DISTRIBUTOR: {
        this.isDistributorRole = true;
        break;
      }

      case USER_ROLE.ANALYTICS: {
        this.isAnalyticsRole = true;
        break;
      }
      case USER_ROLE.USER: {
        this.isUserRole = true;
        break;
      }
      case USER_ROLE.VIEWER: {
        this.isViewerRole = true;
        break;
      }
      default: {
        break;
      }
    }

  }
}
